export class Menu {

    nombre : string;
    icono: string;
    items : any[];
    accion: boolean;
    expandir: string;
    visible: boolean
   
    constructor () {
  
        this.visible = false;
        this.accion = false;
        this.expandir = '+';
        this.nombre = '';
        this.icono = "";
        this.items = [];
    }
  
  }